import { AuthClient } from "../data/auth-client";

async function Register(
  nombre,
  email,
  password_hash,
  role_id,
  telefono = null
) {
  try {
    const authClient = new AuthClient();

    // Prepare the data object matching RegistroUsuarioDto
    const userData = {
      nombre,
      email,
      password_hash,
      role_id,
      telefono
    };

    // Remove telefono if it's null/undefined to match optional field
    if (telefono === null || telefono === undefined) {
      delete userData.telefono;
    }
   
    await authClient.register(userData);
  } catch (err) {
    console.error("Register error", err);
    
    // Handle specific error cases if needed
    if (err.response && err.response.data) {
      if (err.response.data.message === 'El correo ya está registrado') {
        throw new Error('El correo ya está registrado');
      }
      throw new Error(err.response.data.message || 'Error al registrar usuario');
    }
    throw new Error("Register error");
  }
}

export default Register;